import React, { useState, useRef } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
  MenuList,
  Box,
  Avatar,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Grid,
  useMediaQuery,
  Badge,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import GridViewIcon from "@mui/icons-material/GridView";
import Logo from "./../../../assets/images/logo.png";
import notificationsIcon from "./../../../assets/svgIcons/bell.svg";
import userd from "./../../../assets/svgIcons/profile.svg";
import logout from "./../../../assets/svgIcons/logout.svg";
import { ROUTES } from "../../../routes/routerConfig";
import { styled } from "@mui/system";
import ProfileAvatar from "../../common/ProfileAvatar";
import { setSelectedIndex } from "../../../services/redux/slices/tabsSlice";
import { useSelector, useDispatch } from "react-redux";
import { authSelector } from "../../../services/redux/slices/authSlice";
import { resetDisbursementButtonValue } from "../../../services/redux/slices/disbursementButtonSlice";
import { setDocumentDiscardModal } from "../../../services/redux/slices/documentFormSlice";
import { Link as RouterLink, useNavigate, useLocation } from "react-router-dom";
import { persistor, RootState } from "../../../services/redux/store";
import { setStatusPopup } from "../../../services/redux/slices/statusPopupSlice";
import { useTheme } from "@mui/material/styles";
import { cleardisbursementButtonSlice } from "../../../services/redux/slices/disbursementButtonSlice";
import { clearPartPaymentType } from "../../../services/redux/slices/documentFormSlice";
import { setProdcuctName } from "../../../services/redux/slices/tabsSlice";
import { setQuickHelpInfoRoute } from "../../../services/redux/slices/tabsSlice";
import notificationsServices from "../../../services/api/service/notificationService";
import {
  notificationSelector,
  setLoadingNotification,
  setNotification,
  setUnreadCount,
} from "../../../services/redux/slices/notificationSlice";
import { encrypt } from "../../../utils/crypto";
import NotificationsDropDown from "../../common/NotificationsDropDown";
import { PURGE } from "redux-persist";
declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void;
    };
  }
}
const SideNavBarMenuMobile: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userProfile } = useSelector(authSelector);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<string>("");
  const [isHovered, setIsHovered] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);
  const anchorProfileRef = useRef<HTMLButtonElement>(null);
  const { unreadCount } = useSelector(notificationSelector);

  const selectedFormType = useSelector(
    (state: RootState) => state?.documentFormSlice
  );
  const notificationType = useSelector(
    (state: RootState) => state?.notification?.notificationType
  );
  const loanCategoryData: any = useSelector(
    (state: RootState) => state?.auth?.loanCategory
  );
  const businessType = useSelector(
    (state: RootState) => state?.auth?.businessType?.name
  );
  const businessTypeId = useSelector(
    (state: RootState) => state?.auth?.businessType?.id
  );
  const location = useLocation();
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));

  const disbForm: any = useSelector(
    (state: RootState) => state.disbursementButtonSlice.disbursementButtonSlice
  );
  const paymentType = useSelector(
    (state: RootState) => state.documentFormSlice.partPaymentType
  );
  const productName = useSelector((state: RootState) => state.tabs.productName);
  const tabType = useSelector((state: RootState) => state.tabs.tabType);

  const termLoanData = useSelector(
    (state: RootState) => state?.auth?.loanCategory
  );

  const BigLogo = styled("img")({
    height: "auto",
    width: "100px",
  });

  const dashboardDataSet = useSelector(
    (state: RootState) => state.dashboardData.sanctionedDisbursedData
  );
  const selectedLoanNumber = useSelector(
    (state: RootState) => state.dashboardData.selectedLoanNumber
  );

  const handleProfileMenuOpen = () => {
    setIsProfileMenuOpen(!isProfileMenuOpen);
  };

  const quickHelpInfoRouteValue = useSelector(
    (state: any) => state.tabs?.quickHelpInfoRoute
  );

  const handleToggle = () => {
    if (disbForm == "createNewRequestBtn") {
      dispatch(cleardisbursementButtonSlice());
    } else if (paymentType == "1" || paymentType == "2") {
      dispatch(clearPartPaymentType());
      const cleanPath = location.pathname;
      navigate(cleanPath, { replace: true });
      localStorage.removeItem("activeFormStep");
    } else if (location?.pathname?.includes("term-loan/view-all-loans")) {
      navigate("/dashboard");
    } else if (
      location?.pathname?.includes("term-loan") &&
      productName != "TermLoanDisbursement"
    ) {
      if (quickHelpInfoRouteValue == "dashboard") {
        dispatch(setQuickHelpInfoRoute(""));
        navigate("/dashboard");
      } else {
        navigate(-1); // Go back to the previous page
      }
    } else if (
      location?.pathname?.includes("term-loan") &&
      productName == "TermLoanDisbursement"
    ) {
      navigate("/dashboard", { replace: true });
      setProdcuctName("TermLoan");
    } else {
      setIsMenuOpen((prevOpen) => !prevOpen);
    }
  };

  const handleClose1 = (event: MouseEvent | TouchEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as Node)) {
      return;
    }

    if (
      anchorProfileRef.current &&
      anchorProfileRef.current.contains(event.target as Node)
    ) {
      return;
    }

    setIsMenuOpen(false);
  };

  const handleListItemClick = (data: { label: string; path: string }) => {
    setSelectedItem(data.label);
    dispatch(resetDisbursementButtonValue());
    if (data?.path === "") {
      if (data?.label === "Fund Request") {
        const matchVal = dashboardDataSet?.find(
          (data: any) => data?.lanNumber === selectedLoanNumber
        );
        if (
          matchVal?.isExistDisbursementAllowdLoan === false ||
          matchVal?.status != "A"
        ) {
          dispatch(setSelectedIndex(0));
          dispatch(
            setStatusPopup({
              status: "no access",
              // message: `Disbursement requests are not permitted for this loan.`,
              message:
                "Disbursement requests are currently unavailable for this loan",
            })
          );
        } else {
          dispatch(setSelectedIndex(1));
        }
      } else if (data?.label === "Payment") {
        if (termLoanData?.TermLoan?.length > 0  && tabType==="Term Loan") {
          var matchVal = dashboardDataSet?.find(
            (data: any) => data?.lanNumber === selectedLoanNumber
          );
          if (matchVal?.status != "A") {
            dispatch(setSelectedIndex(0));
            dispatch(
              setStatusPopup({
                status: "no access",
                // message: `Disbursement requests are not permitted for this loan.`,
                message:
                  "Payment requests are currently unavailable for this loan",
              })
            );
          } else {
            dispatch(setSelectedIndex(2));
          }
        } else if (termLoanData?.Flexi?.length > 0  && tabType==="Flexi Term Loan") {
          var matchVal = dashboardDataSet?.find(
            (data: any) => data?.loanAccountNumber === selectedLoanNumber
          );
          if (matchVal?.statusOfLoan != "A") {
            dispatch(setSelectedIndex(2));
            dispatch(
              setStatusPopup({
                status: "no access",
                // message: `Disbursement requests are not permitted for this loan.`,
                message:
                  "Payment requests are currently unavailable for this loan",
              })
            );
          } else {
            dispatch(setSelectedIndex(2));
          }
        }
      } else if (data?.label === "Documents") {
        dispatch(setSelectedIndex(3));
      } else if (data?.label === "History") {
        dispatch(setSelectedIndex(4));
      } else if (data?.label === "Withdrawal") {
        dispatch(setSelectedIndex(1));
      }
    } else {
      setSelectedItem(data?.path);
      dispatch(setSelectedIndex(0));
    }
    navigate(`/dashboard`, { replace: true });
    setIsMenuOpen(false);
  };

  const handleMouseEnter = (label: string) => {
    setSelectedItem(label);
    setIsHovered(true);
  };

  const handleMouseLeave = (label: string) => {
    setSelectedItem(label);
    setIsHovered(false);
  };

  const handleLogOutMenu = async () => {
    if (
      selectedFormType?.formType === "continue" &&
      selectedFormType?.isNewData
    ) {
      dispatch(setDocumentDiscardModal());
    } else {
      dispatch({ type: 'USER_LOGOUT' });  // after logout api calls and navigation was working, so this is the fix for that 
      window?.ReactNativeWebView?.postMessage(
        JSON.stringify({ type: "LOGOUT" })
      );
      localStorage.removeItem("selectedIndex");
      // dispatch({ type: PURGE, key: 'root' });
      handleProfileMenuOpen();
      sessionStorage?.clear();
      await persistor.purge(); // clearing redux store
      window.location.href = "/login";
    }
  };

  const getNotificationsListMobile = async () => {
    if (!notificationType || notificationType.trim() === "") {
      return;
    }
    dispatch(setLoadingNotification(true));
    try {
      const bodyObj: any = {};
      let cifNumber = userProfile?.cifNumber;
      let cifEntity = userProfile?.cifEntity;
      if (
        loanCategoryData?.Flexi?.length > 0 &&
        loanCategoryData?.TermLoan?.length > 0
      ) {
        if (businessType == "retail" && notificationType == "Term Loan") {
          bodyObj.cifNumber = cifNumber;
          bodyObj.businessType = encrypt(businessTypeId);
          bodyObj.loanCategory = encrypt(
            loanCategoryData?.TermLoan[0]?.loanCategoryId
          );
        } else if (
          businessType == "flexi" &&
          notificationType == "Flexi Term Loan"
        ) {
          bodyObj.cifNumber = cifNumber;
          bodyObj.businessType = encrypt(businessTypeId);
          bodyObj.loanCategory = encrypt(
            loanCategoryData?.Flexi[0]?.loanCategoryId
          );
        } else if (
          businessType == "retail" &&
          notificationType == "Flexi Term Loan"
        ) {
          bodyObj.cifNumber = cifNumber;
          bodyObj.businessType = encrypt(businessTypeId);
          bodyObj.loanCategory = encrypt(
            loanCategoryData?.Flexi[0]?.loanCategoryId
          );
        } else {
          bodyObj.cifEntity = cifEntity;
          bodyObj.businessType = encrypt(businessTypeId);
          bodyObj.loanCategory = encrypt(
            loanCategoryData?.Flexi[0]?.loanCategoryId
          );
        }
      } else {
        if (businessType == "retail" && notificationType == "Term Loan") {
          bodyObj.cifNumber = cifNumber;
          bodyObj.businessType = encrypt(businessTypeId);
          bodyObj.loanCategory = encrypt(
            loanCategoryData?.TermLoan[0]?.loanCategoryId
          );
        } else if (
          businessType == "retail" &&
          notificationType == "Flexi Term Loan"
        ) {
          bodyObj.cifNumber = cifNumber;
          bodyObj.businessType = encrypt(businessTypeId);
          bodyObj.loanCategory = encrypt(
            loanCategoryData?.Flexi[0]?.loanCategoryId
          );
        } else if (
          businessType == "entity" &&
          loanCategoryData?.TermLoan?.length > 0
        ) {
          bodyObj.cifNumber = cifNumber;
          bodyObj.businessType = encrypt(businessTypeId);
          bodyObj.loanCategory = encrypt(
            loanCategoryData?.TermLoan[0]?.loanCategoryId
          );
        } else {
          //bodyObj.cifEntity = cifEntity;
          bodyObj.businessType = encrypt(businessTypeId);
          bodyObj.loanCategory = encrypt(
            loanCategoryData?.Flexi[0]?.loanCategoryId
          );
        }
      }
      const res = await notificationsServices.getNotifications(bodyObj);

      if (res?.status == 200 && res?.data?.data) {
        const notificationsList = res?.data?.data?.filter(
          (n: any) => n.readStatus === false
        );
        const unreadCount = res?.data?.pagination?.unreadNotificationsCounts;
        dispatch(setNotification(notificationsList));
        dispatch(setUnreadCount(unreadCount));
      }
    } catch (error) {
      console.error("get notifications API error::", error);
    }
    dispatch(setLoadingNotification(false));
  };
  // notifications Drop Down
  const [anchorNotifyEl, setAnchorNotifyEl] =
    React.useState<HTMLButtonElement | null>(null);

  const handleBellClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorNotifyEl(event.currentTarget);
  };
  const openNotify = Boolean(anchorNotifyEl);

  const handleBellClose = () => {
    setAnchorNotifyEl(null);
  };

  React.useEffect(() => {
    if (openNotify) {
      // getNotificationsList();
    }
  }, []);
  //  }, [openNotify, notificationType, loanCategoryData]);

  React.useEffect(() => {
    if (!openNotify) {
      //getNotificationsList();
    }
  }, [notificationType, loanCategoryData]);
  return (
    <div>
      <Box
        position="static"
        sx={{
          backgroundColor: "white",
          boxShadow: "0px 2px 4px 0px rgba(165, 163, 174, 0.3)",
          transition: "all 0.3s ease",
          borderRadius: "6px",
        }}
        mb={2}
      >
        <Toolbar>
          <Grid
            container
            direction="column"
            alignItems="center"
            sx={{ width: "100%", display: "contents" }}
          >
            <Grid item xs={2}>
              <IconButton
                edge="start"
                color="inherit"
                aria-label="menu"
                ref={anchorRef}
                onClick={() => handleToggle()}
                sx={{ color: "black" }}
              >
                {location?.pathname?.includes("term-loan") ||
                location?.pathname?.includes("view-all-loans") ||
                disbForm == "createNewRequestBtn" ||
                paymentType == "1" ||
                paymentType == "2" ? (
                  <ArrowBackIosNewIcon
                    sx={{ color: "rgba(75, 70, 92, 0.7)" }}
                  />
                ) : (
                  <MenuIcon />
                )}
              </IconButton>
            </Grid>
            <Grid item xs={6} sx={{ textAlign: "center" }}>
              <BigLogo src={Logo} alt="Logo" />
            </Grid>
            <Grid item xs={2}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                  padding: "0px",
                }}
              >
                <IconButton
                  onClick={handleBellClick}
                  size="large"
                  aria-label="show 5 new notifications"
                  sx={{
                    "&:hover": {
                      backgroundColor: "transparent",
                      boxShadow: "none",
                    },
                  }}
                >
                  <Badge badgeContent={unreadCount} color="error">
                    <img src={notificationsIcon} alt="Notifications " />
                  </Badge>
                </IconButton>
              </Box>
            </Grid>
            <Grid item xs={2}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                  padding: "0px",
                }}
              >
                <IconButton
                  sx={{
                    padding: "0px",
                    "&:hover": {
                      backgroundColor: "transparent",
                      boxShadow: "none",
                    },
                  }}
                  size="large"
                  aria-label="account of current user"
                  aria-controls="profile-menu"
                  aria-haspopup="true"
                  onClick={handleProfileMenuOpen}
                  id={"profile-menu"}
                  ref={anchorProfileRef}
                >
                  <ProfileAvatar
                    name={userProfile?.name}
                    src={userProfile?.profileImage}
                    size={40}
                  />
                </IconButton>
              </Box>
            </Grid>
          </Grid>
        </Toolbar>
      </Box>

      <Popper
        id={"profile-menu"}
        open={isProfileMenuOpen}
        anchorEl={anchorProfileRef.current}
        placement="bottom-end"
        transition
        disablePortal
        style={{ zIndex: 1300 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom-end" ? "right top" : "right bottom",
              // transform: window.innerWidth > 1000 ? "translateX(0%)" : "translateX(260%)"
            }}
          >
            <Paper>
              <ClickAwayListener
                onClickAway={() => setIsProfileMenuOpen(false)}
              >
                <MenuList
                  autoFocusItem={isProfileMenuOpen}
                  id="profile-menu-list-grow"
                >
                  <ListItem
                    sx={{
                      height: 38,
                    }}
                    onClick={() => {
                      if (
                        selectedFormType?.formType === "continue" &&
                        selectedFormType?.isNewData
                      ) {
                        dispatch(setDocumentDiscardModal());
                      } else {
                        navigate("/profile");
                        handleProfileMenuOpen();
                      }
                    }}
                  >
                    <img src={userd} alt="user" style={{ width: "16px" }} />{" "}
                    &nbsp; <ListItemText primary="Profile" />
                  </ListItem>
                  <ListItem
                    onClick={handleLogOutMenu}
                    sx={{
                      height: 38,
                    }}
                  >
                    <img src={logout} alt="log out" style={{ width: "16px" }} />{" "}
                    &nbsp; <ListItemText primary="Logout" />
                  </ListItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>

      <Popper
        open={isMenuOpen}
        anchorEl={anchorRef.current}
        role={undefined}
        placement="bottom-start"
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              width: "240px",
              marginTop: "20px",
              transformOrigin:
                placement === "bottom-start" ? "top" : "left bottom",
            }}
          >
            <Paper sx={{ minWidth: "180px" }}>
              <ClickAwayListener onClickAway={handleClose1}>
                <MenuList autoFocusItem={isMenuOpen} id="menu-list-grow">

                  {termLoanData?.TermLoan.length > 0  &&  (tabType === "Term Loan")&& (
                    <>
                      {ROUTES?.SidNavBarMenuOptions?.map((link, index) => (
                        <ListItem
                          key={index}
                          disablePadding
                          sx={{
                            display: "block",
                            height: 36,
                          }}
                        >
                          <ListItemButton
                            selected={selectedItem === link.label}
                            onClick={() => handleListItemClick(link)}
                            onMouseEnter={() => handleMouseEnter(link.label)}
                            onMouseLeave={() => handleMouseLeave(link.label)}
                            sx={{
                              height: 54,
                              justifyContent: isMenuOpen ? "initial" : "center",
                              px: 2.5,
                              backgroundColor:
                                selectedItem === link.label ? "red" : "initial",
                            }}
                          >
                            {/* <ListItemIcon
                          sx={{
                            mr: isMenuOpen ? 3 : "auto",
                            justifyContent: "center",
                            height: 54,
                            marginRight: "0px",
                          }}
                        >
                          {link?.path !== "" ? (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: 53,
                                height: 50,
                              }}
                            >
                              {isHovered ? (
                                <img
                                  src={Logo}
                                  alt="Hover Logo"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain",
                                  }}
                                />
                              ) : (
                                <GridViewIcon
                                  sx={{
                                    fontSize: 20,
                                    color: "gray",
                                  }}
                                />
                              )}
                            </Box>
                          ) : (
                            <img
                              src={link?.icon}
                              alt="icon"
                              style={{
                                display: "block",
                                width: "56px",
                                height: "41px",
                                marginTop: "6px",
                                objectFit: "contain",
                              }}
                            />
                          )}
                        </ListItemIcon> */}

                            <ListItemText
                              primary={link.label}
                              sx={{
                                opacity: isMenuOpen ? 1 : 0,
                                color: "#5d586c",
                                fontSize: "15px",
                                fontFamily: "Jost",
                                fontWeight: "500",
                                lineHeight: "22px",
                              }}
                            />
                          </ListItemButton>
                        </ListItem>
                      ))}
                    </>
                  )}

                  {termLoanData?.Flexi.length > 0  &&  (tabType === "Flexi Term Loan")&& (
                    <>
                      {ROUTES?.SideNavBarMenuFlexiOptions?.map(
                        (link, index) => (
                          <ListItem
                            key={index}
                            disablePadding
                            sx={{
                              display: "block",
                              height: 36,
                            }}
                          >
                            <ListItemButton
                              selected={selectedItem === link.label}
                              onClick={() => handleListItemClick(link)}
                              onMouseEnter={() => handleMouseEnter(link.label)}
                              onMouseLeave={() => handleMouseLeave(link.label)}
                              sx={{
                                height: 54,
                                justifyContent: isMenuOpen
                                  ? "initial"
                                  : "center",
                                px: 2.5,
                                backgroundColor:
                                  selectedItem === link.label
                                    ? "red"
                                    : "initial",
                              }}
                            >
                              {/* <ListItemIcon
                          sx={{
                            mr: isMenuOpen ? 3 : "auto",
                            justifyContent: "center",
                            height: 54,
                            marginRight: "0px",
                          }}
                        >
                          {link?.path !== "" ? (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: 53,
                                height: 50,
                              }}
                            >
                              {isHovered ? (
                                <img
                                  src={Logo}
                                  alt="Hover Logo"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain",
                                  }}
                                />
                              ) : (
                                <GridViewIcon
                                  sx={{
                                    fontSize: 20,
                                    color: "gray",
                                  }}
                                />
                              )}
                            </Box>
                          ) : (
                            <img
                              src={link?.icon}
                              alt="icon"
                              style={{
                                display: "block",
                                width: "56px",
                                height: "41px",
                                marginTop: "6px",
                                objectFit: "contain",
                              }}
                            />
                          )}
                        </ListItemIcon> */}

                              <ListItemText
                                primary={link.label}
                                sx={{
                                  opacity: isMenuOpen ? 1 : 0,
                                  color: "#5d586c",
                                  fontSize: "15px",
                                  fontFamily: "Jost",
                                  fontWeight: "500",
                                  lineHeight: "22px",
                                }}
                              />
                            </ListItemButton>
                          </ListItem>
                        )
                      )}
                    </>
                  )}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
      <NotificationsDropDown
        open={openNotify}
        anchorEl={anchorNotifyEl}
        handleClose={handleBellClose}
      />
      {/* <NotificationsDropDown
        open={openNotify}
        anchorEl={anchorNotifyEl}
        handleClose={handleBellClose}
      /> */}
    </div>
  );
};

export default SideNavBarMenuMobile;
